import { useContext, useState } from "react";
import logo from './assets/logo.png';
import english from './assets/en.png';
import spanish from './assets/spanish.png';
import { LanguageContext } from "./context/LanguageContext";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import { IoMdArrowDropdown } from "react-icons/io";
import axios from "axios";
import { Link } from "react-router-dom";

const Main = () => {
    const [step, setStep] = useState(1);
    const { language, toggleLanguage } = useContext(LanguageContext);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);
    const [downloadDropdownOpen, setDownloadDropdownOpen] = useState(false);


    const handleLanguageChange = (lang) => {
        if (lang !== language) toggleLanguage();
        setDropdownOpen(false);
    };

    const [formData, setFormData] = useState({
        corporateName: "",
        tradeName: "",
        address: "",
        cityStateZip: "",
        emailtransactionconfirmation: "",
        phone: "",
        website: "",
        typeOfBusiness: "",
        dateOfIncorporation: "",
        taxIdNumber: "",
        purposeOfTransactions: "",
        annualVolume: "",
        transactionsPerMonth: "",
        paymentMethod: "",
        bankName: "",
        bankAddress: "",
        accountNumber: "",
        currencies: "",
        abaNumberRoutingCode: "",
        accountType: "",
        authorizedUserName: "",
        authorizedUserTitle: "",
        authorizedUserPhone: "",
        authorizedUserEmail: "",
        beneficialName: "",
        beneficialDateOfBirth: "",
        beneficialPercentage: "",
        authorizationName: "",
        authorizationTitle: "",
        authorizationDate: "",
        privacyPolicy: "",
        agreeTerms: "",
        signature: "" // Add signature field
    });

    const handleNext = () => setStep((prev) => prev + 1);
    const handlePrev = () => setStep((prev) => prev - 1);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // const handleSubmit = async () => { // Remove `e` since it's not needed here
    //     if (!process.env.REACT_APP_API_URI) {
    //         console.error("API URI is not defined in the environment variables.");
    //         alert("Internal error. Please contact support.");
    //         return;
    //     }

    //     try {
    //         const response = await axios.post(process.env.REACT_APP_API_URI, formData, {
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //         });

    //         if (response.status === 200) {
    //             alert("Registration successful!");
    //             window.location.href = "https://tkambio.us";
    //         } else {
    //             alert("Something went wrong. Please try again.");
    //             console.error("Unexpected response:", response);
    //         }
    //     } catch (error) {
    //         console.error("Registration failed:", error);
    //         alert("Failed to submit the registration. Please check your input and try again.");
    //     }
    // };


    const handleSubmit = async () => {
        console.log("Form Data being sent:", formData); // Debug here
        if (!process.env.REACT_APP_API_URI) {
            console.error("API URI is not defined in the environment variables.");
            alert("Internal error. Please contact support.");
            return;
        }

        try {
            const response = await axios.post(process.env.REACT_APP_API_URI, formData, {
                headers: { "Content-Type": "application/json" },
            });

            if (response.status === 200) {
                console.log("Response:", response.data); // Debug response
                alert("Registration successful!");
                window.location.href = "https://tkambio.us";
            } else {
                alert("Something went wrong. Please try again.");
                console.error("Unexpected response:", response);
            }
        } catch (error) {
            console.error("Registration failed:", error.response ? error.response.data : error.message);
            alert("Failed to submit the registration. Please check your input and try again.");
        }
    };

    const steps = [
        <Step1 formData={formData} handleChange={handleChange} handleNext={handleNext} />,
        <Step2 formData={formData} handleChange={handleChange} handleNext={handleNext} handlePrev={handlePrev} />,
        <Step3 formData={formData} handleChange={handleChange} handlePrev={handlePrev} handleSubmit={handleSubmit} />,
    ];

    return (
        <div className="max-w-[1300px] md:mx-auto bg-gray-100">
            <div className="flex justify-between items-center my-6">
                <Link to='https://tkambio.us'><img src={logo} alt="" /></Link>
                <div>
                    <div className="flex items-center gap-4">
                        <div className="relative inline-block">
                            <button
                                onClick={() => {
                                    setDownloadDropdownOpen(!downloadDropdownOpen);
                                    setLanguageDropdownOpen(false); // Close the language dropdown if open
                                }}
                                className="bg-primary text-white rounded-lg py-2 px-6 text-xl flex items-center gap-1"
                            >
                                {language === 'en' ? 'Download Form' : 'Descarga la forma'}
                                <IoMdArrowDropdown />
                            </button>
                            {downloadDropdownOpen && (
                                <div className="absolute z-10 mt-2 bg-white border border-gray-300 rounded shadow-md w-52">
                                    <Link
                                        className="block p-2 text-primary hover:bg-gray-100"
                                        to="https://monexusa.na2.documents.adobe.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhAUJ8Hp-hx-GSCg3LZA_RBFs1274-I-lyapBBkSbCnosysnaVrGhDuevq7MfiSYtJo*"
                                        target="_blank"
                                    >
                                        {language === 'en' ? 'For US Companies' : 'Para empresas de EE.UU.'}
                                    </Link>
                                    <Link
                                        className="block p-2 text-primary hover:bg-gray-100"
                                        to="https://monexusa.na2.documents.adobe.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhByU8pqhOG2PCC_LNdvj9m3IpIKyg59eC1gYEzMETEW4PnnMc7zQZOcawVoMmFAoEM*"
                                        target="_blank"
                                    >
                                        {language === 'en' ? 'For Non-US Companies' : 'Para empresas no estadounidenses'}
                                    </Link>
                                </div>
                            )}
                        </div>

                        <button
                            onClick={() => handleLanguageChange(language === "en" ? "es" : "en")}
                            className="text-sm text-primary rounded px-2 py-1 flex items-center gap-1"
                        >
                            <img
                                alt="Language"
                                className="w-[20px]"
                                src={language === "en" ? spanish : english}
                            />
                            <span className="text-lg uppercase">{language === "en" ? "Es" : "En"}</span>
                        </button>

                    </div>
                </div>
            </div>

            <div className="relative w-full h-2 bg-gray-200 rounded-full mb-4">
                <div
                    className="absolute top-0 left-0 h-full bg-primary rounded-full transition-all"
                    style={{ width: `${(step / steps.length) * 100}%` }}
                ></div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md my-9">
                {steps[step - 1]}
            </div>
        </div>
    );
};

export default Main;